<section class="confirm">
  <div class="confirm__message">
    <h2 *ngIf="!message.title">{{ message | translate }}</h2>
    <h2 *ngIf="message.title">{{ message.title | translate }}</h2>
    <p *ngIf="message.title && message.description">{{ message.description | translate }}</p>
  </div>
  <div class="buttons">
    <button mat-raised-button color="primary" (click)="confirm()">OK</button>
  </div>
</section>
